<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <!--<router-link :to="{name: 'Add Image'}">-->
                <!--<el-button type="primary" class="fluid">{{ $t('add') }} Scenę <i class="el-icon-plus"></i>-->
                <!--</el-button>-->
                <!--</router-link>-->
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="70"></el-table-column>
                    <el-table-column label="zdjęcie">
                        <template slot-scope="scope">
                            <img :src="scope.row.thumbnail" :alt="scope.row.alt_pl">
                        </template>
                    </el-table-column>
                    <el-table-column label="autor">
                        <template slot-scope="scope">
                            <el-input v-if="photoDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].author"
                                      type="text"/>
                            <span v-show="!photoDuringEdition(scope.row)">{{ scope.row.author }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="alt (pl)">
                        <template slot-scope="scope">
                            <el-input v-if="photoDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].alt_pl"
                                      type="text"/>
                            <span v-show="!photoDuringEdition(scope.row)">{{ scope.row.alt_pl }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="alt (en)">
                        <template slot-scope="scope">
                            <el-input v-if="photoDuringEdition(scope.row)"
                                      v-model="duringEditing[scope.row.id].alt_en"
                                      type="text"/>
                            <span v-show="!photoDuringEdition(scope.row)">{{ scope.row.alt_en }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="opcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <el-button title="Edytuj szczegóły zdjęcia"
                                       v-show="!photoDuringEdition(scope.row)"
                                       size="small"
                                       @click="editPhoto(scope.row)"><i
                                    class="el-icon-edit"></i>
                            </el-button>
                            <el-button title="Zatwierdź edycję"
                                       v-show="photoDuringEdition(scope.row)"
                                       size="small"
                                       type="primary"
                                       @click="submitEditedPhoto(scope.row)"><i
                                    class="el-icon-check"></i>
                            </el-button>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col :span="24" class="list__pagination">
                <el-pagination layout="prev, pager, next"
                               @current-change="handlePageChange"
                               :page-size="pageSize" :total="count">
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {Image} from '@/api';
    import ListFilterComponent from '@/components/ListFilterComponent'

    export default {
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                data: [],
                listLoading: false,
                service: Image,
                pageSize: 10,
                count: 0,
                page: 1,
                duringEditing: {}
            }
        },
        methods: {
            photoDuringEdition (photo) {
                return this.duringEditing[photo.id] !== undefined
            },
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter () {
                this.page = 1
                this.fetchData()
            },
            editPhoto (photo) {
                this.$set(this.duringEditing, photo.id, photo)
            },
            submitEditedPhoto (photo) {
                Image.update(photo.id, this.duringEditing[photo.id]).then(response => {
                    this.$message({
                        message: 'Element został zaaktualizowany',
                        type: 'success'
                    })
                    this.duringEditing[photo.id] = undefined
                    this.fetchData(true)
                })
            },
            fetchData (soft) {
                let params = {
                    page: this.page,
                    ...this.filters.selected
                };
                if (soft === undefined) {
                    this.listLoading = true;
                }
                this.service.fetch({}, {params}).then(response => {
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.data = response.data.results;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        mounted () {
            this.fetchData();
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ImagesList.vue?2cb31411